import React from "react";
import propTypes from "prop-types";
import cx from "classnames";
// eslint-disable-next-line import/no-cycle
import { MagazinePreviewBlock as MagazinePreviewBlockComponent } from "../../sharedComponents/MagazinePreviewBlock";
import * as styles from "./MagazinePreviewBlock.module.scss";

const MagazinePreviewBlock = ({
	blockImage,
	blockText,
	magazineCoverImageCloudinaryUrl,
	sourceSet,
	magazineLink,
	blockImageCloudinary,
	magazineModal,
}) => {
	const customClasses = {
		card: cx(styles.magazineCardCustom),
		cardImageContainer: cx(styles.cardImageContainerCustom),
		magazineImageContainer: cx(styles.magazineImageContainerCustom),
		description: cx(styles.cardDescriptionCustom),
		previewLink: cx(styles.previewLinkCustom),
		text: cx(styles.cardTextCustom),
		magazineImage: cx(styles.magazineImageCustom),
	};
	return (
		<MagazinePreviewBlockComponent
			blockImage={blockImageCloudinary || blockImage}
			sourceSet={sourceSet}
			blockText={blockText}
			magazineCoverImageUrl={magazineCoverImageCloudinaryUrl}
			magazineLink={magazineLink}
			styles={styles}
			magazineModal={magazineModal}
			customClasses={customClasses}
		/>
	);
};

MagazinePreviewBlock.propTypes = {
	blockImageCloudinary: propTypes.arrayOf(
		propTypes.shape({
			secure_url: propTypes.string,
			format: propTypes.string,
			height: propTypes.number,
			public_id: propTypes.string,
			raw_transformation: propTypes.string,
			version: propTypes.number,
			width: propTypes.number,
		})
	),
	sourceSet: propTypes.arrayOf(
		propTypes.shape({
			cloudinaryAsset: propTypes.object,
			contentful_id: propTypes.string,
			id: propTypes.string,
			sourceSetDisplayedAt: propTypes.string,
			title: propTypes.string,
		})
	),
	blockImage: propTypes.shape({
		file: propTypes.shape({
			url: propTypes.string,
		}),
	}),
	blockText: propTypes.string,
	magazineCoverImageCloudinaryUrl: propTypes.string,
	magazineLink: propTypes.shape({
		linkText: propTypes.string,
		url: propTypes.string,
		target: propTypes.string,
	}),
	magazineModal: propTypes.shape({
		componentType: propTypes.string,
		configuration: propTypes.shape({
			internal: propTypes.shape({
				content: propTypes.string,
			}),
		}),
	}),
};
MagazinePreviewBlock.defaultProps = {
	blockImageCloudinary: null,
	sourceSet: null,
	blockImage: null,
	blockText: null,
	magazineCoverImageCloudinaryUrl: null,
	magazineLink: null,
	magazineModal: null,
};

export default MagazinePreviewBlock;
export { MagazinePreviewBlock };
